import * as React from 'react';
import { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { ReactComponent as CheckBoxOutlined } from "assets/icons/check-box-outlined.svg";
import { evalPath } from 'helpers/HelperFunctions';
import hexRgb from "hex-rgb"

import {
    AssignmentLate as MyActionsIcon
    , History
    , Apps
    , Announcement as AwaitingActionIcon
    , Star as FavouriteIcon
    , KeyboardArrowDown
    , ArrowForwardIos
    , Folder as CurrentDocuments
    , Folder
    , Delete
    , Create as AdminEditIcon
    , History as AdminRescindIcon
    , CancelOutlined as CancelIcon
    , Info as ToolTipIcon
    , Info
    , Help as ToolTipQuestionIcon
    , Create as EditIcon
    , DeleteOutlined as DeleteIcon
    , ReportProblem as ValidationIcon
    , AddCircle as AddRelatedDocumentsIcon
    , ExpandMore,
    CheckBoxOutlineBlankOutlined
} from '@mui/icons-material';


//import {Button} from 'reactstrap'

import {
    IDocumentModule, IDocumentFilter, DocumentViews, IDocumentView, getClassName, DocumentModules, defaultDocumentIcon, FilterIcon,
    RailRulebookDocumentModuleTraditional, RailRulebookDocumentModuleCBTC, IRailDocumentCache, defaultDocumentFilter
} from "../ui/DocumentRules";

import { ReactComponent as RailDocsIcon } from "assets/icons/rail-docs-filled.svg";
import { ReactComponent as RecentActionsIcon } from "assets/icons/doc-recently-acknowledged-filled.svg";
import { ReactComponent as MemosIcon } from "assets/icons/rd-memo.svg";
import { ReactComponent as WorkInstructionsIcon } from "assets/icons/rd-wins.svg";
import { ReactComponent as QuickLinksIcon } from "assets/icons/link-filled.svg";
import { ReactComponent as MarkChatReadIcon } from "assets/icons/mark-chat-read.svg";
import { ReactComponent as OperatingInstructionsNoticesIcon } from "assets/icons/rb-operating-notices.svg";;

import { ReactComponent as RbNetworkRulesIcon } from "assets/icons/rb-network-rules.svg";
import { ReactComponent as RbNetworkProcsIcon } from "assets/icons/rb-network-procs.svg";
import { ReactComponent as RbNetworkFormsIcon } from "assets/icons/rb-network-rules-forms.svg";
import { ReactComponent as RbRailTrafficOperationsManualIcon } from "assets/icons/rb-operations-manual.svg";
import { ReactComponent as RbSignallingIcon } from "assets/icons/rb-signalling.svg";
import { ReactComponent as RbGlossary } from "assets/icons/rb-glossary.svg";
import { ReactComponent as RbRulebookFilled } from "assets/icons/rb-rulebook-filled.svg";

import { ReactComponent as AdminAddNewDocumentIcon } from "assets/icons/admin-add-new-document.svg";
import { ReactComponent as AdminExpiredDocumentsIcon } from "assets/icons/admin-expired-documents.svg";

import { ReactComponent as RbNrGeneralRules } from "assets/icons/rb-nr-general-rules.svg";
import { ReactComponent as RbNrRailTrafficOperations } from "assets/icons/rb-nr-rail-traffic-operations.svg";
import { ReactComponent as RbNrSignallingOperations } from "assets/icons/rb-nr-signalling-operations.svg";
import { ReactComponent as RbNrWorkOnTrack } from "assets/icons/rb-nr-work-on-track.svg";

import { ReactComponent as PdfIcon } from "assets/icons/pdf-icon.svg";

import { DocumentType as RailDocumentType } from "shared/models/site/document-type"

import "./Labels.css";
import { colorCssMapping, colors } from "shared/helpers/colorManager"
import { FormGroup, Input, Label } from 'reactstrap';
import { useAllDocumentTypes } from 'hooks/useDocumentType';
import { Floating, Toggle } from '../ui/ToggleContent';
import { RailDocument } from '../../shared/models/api/models';
import { SortOrder } from '../portal/GridComponents';
import { RulebookModeEnum, RulebookNameToEnum } from '../../shared/enums/rulebook-mode-enum';
import { getUserExistingRulebookMode } from '../../shared/store/applicationState';

// TODO make heading responsive
/* All labels and icon menus should go here so all the icons are imported in a central place */


export const IconHeading = (props: { icon: React.ReactNode, headingText: string, width?: string, altColor?: boolean }) => {
    const style = props.width ? { maxWidth: props.width } : {};

    let className = "primary-card-heading pb-1";
    className += props.width ? " primary-card-heading-underline" : "";
    className += props.altColor ? " alternate-text" : "";

    return (
        <div className="icon-heading">
            <span className={className} style={style} >
                <div style={{ float: 'left' }}>{props.icon}</div>&nbsp;{props.headingText}
            </span>
        </div>
    );
}

const IconHeading2 = (props: { icon: React.ReactNode, headingText: string, width?: string, altColor?: boolean }) => {
    let className = "secondary-card-heading pb-1";
    className += props.altColor ? " alternate-text" : "";
    return (
        <div className={className} style={{ display: "inline-block" }}>
            <div style={{ float: 'left' }}>{props.icon}</div>
            <div style={{ float: 'left', margin: '4px' }}>{props.headingText}</div>
            <ExpandMore />
        </div>
    );
}

export const IconHeading3 = (props: { icon: React.ReactNode, headingText: string, width?: string, altColor?: boolean }) => {
    let className = "secondary-card-heading pb-1";
    className += props.altColor ? " alternate-text" : "";
    return (
        <div className={className} style={{ display: "inline-block" }}>
            <div className="h3-icon m-3">{props.icon}</div>
            <div className="h3-text m-2 mt-4 pt-2">{props.headingText}</div>
        </div>
    );
}

const GridButton = (props: { icon: React.ReactNode, headingText: string, onClick: () => void, altColor?: boolean }) => {

    const buttonColor = colors["silver"];
    const iconBgColor = SetAlphaColor(buttonColor, "0.5");
    const buttonTextBgColor = SetAlphaColor(buttonColor, "0.25");

    return (
        <div className="ml-2 mr-2 rail-button" onClick={() => props.onClick()} >
            <span className="p-1" style={{ backgroundColor: iconBgColor }}>{props.icon}</span><span className="p-1" style={{ backgroundColor: buttonTextBgColor }}>{props.headingText}</span>
        </div>
    );
}

interface IIconSubMenu {
    text: string,
    selectFn: () => void,
    icon?: React.ReactNode;
}

const SetAlphaColor = (hexColor: string, alpha: string): string => {

    const rgbColor = hexRgb(hexColor || "#000000", { format: "array" });
    return `rgb(${rgbColor["0"]}, ${rgbColor["1"]},${rgbColor["2"]}, ${alpha})`;
}

// Properties common to level 1 and level 2 menus
type IIconMenuProps = {
    icon?: React.ReactNode,
    text: string,
    color: string,
    isActive?: boolean,
    toggleActive?: () => void,
    leafItems?: ILeafItem[],
    maxItems?: number
}

export type ILeafItem = {
    parent: string,
    text: string,
    id: number,
    selected: boolean,
    selectAction?: (item: ILeafItem) => void,
    clickAction?: (item: ILeafItem) => void
}

type IRootIconMenuProps = {
    subMenus?: IIconSubMenu[],
}

const IconLeafMenus = (props: { isActive?: boolean, leafItems?: ILeafItem[], maxItems?: number }) => {
    if (props.leafItems && props.leafItems.length > 0) {
    }

    const navigate = useNavigate();

    const [leafItems, setLeafItems] = useState(props.leafItems);

    const onLeafSelected = (l: ILeafItem) => {
        l.selected = !l.selected;
        if (l.selectAction) l.selectAction(l);
        setLeafItems((leafItems || []).filter(x => true));
    }

    const mode = getUserExistingRulebookMode();

    const navigateToRulebook = (type: string) => {
        // this will likely not work, but I dont think this leaf component is used, will find out when i clean up a bit
        if (RulebookNameToEnum(mode) === RulebookModeEnum.Traditional) {
            navigate(`${RailRulebookDocumentModuleTraditional.url}/${type.replaceAll(' ', '',)}`);
        } else if (RulebookNameToEnum(mode) === RulebookModeEnum.CBTC) {
            navigate(`${RailRulebookDocumentModuleCBTC.url}/${type.replaceAll(' ', '',)}`);
        } else {
            console.log('Redirection to RailRulebookDocumentModule failed - document mode is not set');
        }        
    }

    return (
        <React.Fragment>
            {
                (props.isActive && leafItems) && leafItems.map((x, i) =>
                (
                    <>
                        {(typeof (props.maxItems) !== "number" || (typeof (props.maxItems) === "number" && i < props.maxItems)) &&
                            <div key={i} className="icon-menu-item-container2 user-select-none">
                                <span className={`${x.clickAction && 'clickable'}`} onClick={() => { if (x.clickAction) x.clickAction(x) }} >
                                    {x.selectAction && <Input type="checkbox" checked={x.selected} onChange={() => onLeafSelected(x)} />}
                                    {x.clickAction && <PdfIcon />}
                                    <div style={{ float: 'left', height: '1.5rem', maxWidth: '3.25rem', minWidth: '3.25rem' }}>&nbsp;</div><span >{x.text}</span>
                                </span>
                            </div>
                        }
                        {i === props.maxItems &&
                            <div className="pl-5 font-weight-bold icon-menu-item-container2 user-select-none" onClick={() => navigateToRulebook(x.parent)}>
                                <span className="clickable">See all {x.parent}</span>
                            </div>
                        }
                    </>
                ))
            }
        </React.Fragment>
    );
}

// Level 1 Menu with icons on colored bar
// Note this menu structure only supports 2 levels as per requirements
export const IconMenuItem1 = (props: IIconMenuProps & IRootIconMenuProps) => {

    const [isHover, setIsHover] = useState(false);
    const [isFocus, setIsFocus] = useState(false);
    const [activeSubMenu, setActiveSubMenu] = useState(-1);

    const toggleHover = () => { setIsHover(!isHover); };
    const toggleActive = () => { if (props.toggleActive) props.toggleActive(); };
    const toggleFocus = () => { setIsFocus(!isFocus) };
    const subMenus = props.subMenus || [];
    // If leaf items are passed in but they aren't visible then 
    var isVisible = true;
    var leafItems = [] as Array<ILeafItem>;
    if (props.leafItems) {
        leafItems = (props.leafItems).filter(x => x.parent === props.text);
        const subMenuItems = subMenus.filter(x => { return (props.leafItems?.filter(l => l.parent == x.text) || []).length > 0 });
        // this can be set via an option if there is a requirement to hide empty menus later
        //isVisible = leafItems.length > 0 || subMenuItems.length > 0;
    }
    var style = {};

    const Caret = () => (
        <>
            {
                (props.isActive && props.subMenus)
                    ? <KeyboardArrowDown />
                    : props.isActive && <ArrowForwardIos />
            }
        </>
    );

    const SubMenus = () => {
        const toggleSubActive = (menuIndex: number) => {
            setActiveSubMenu(menuIndex === activeSubMenu ? -1 : menuIndex);
        }
        return (
            <>
                {
                    props.isActive && subMenus.map((x, i) => (
                        <IconMenuItem2 {...props}
                            key={i}
                            selectFn={x.selectFn}
                            icon={x.icon}
                            text={x.text}
                            isActive={activeSubMenu === i}
                            toggleActive={() => toggleSubActive(i)} />))
                }
            </>
        );
    };

    if (isHover || isFocus || props.isActive) {
        style = {
            backgroundColor: SetAlphaColor(props.color, '0.25')
        }
    }

    return (
        <>
            {
                isVisible &&
                <>
                    <div className="icon-menu-item-container user-select-none "
                        onMouseOver={toggleHover}
                        onMouseOut={toggleHover}
                        onClick={toggleActive}
                        onFocus={toggleFocus}
                        style={style}
                    >
                        <div className="status-frame" style={{ backgroundColor: props.color }} />
                        <div className="pt-3" >
                            <div style={{ float: 'left', height: '2.5rem', maxWidth: '3.25rem' }}  >{props.icon}</div>&nbsp;<span className="large-text">{props.text}</span><div style={{ float: 'right' }}><Caret /></div>
                        </div>
                    </div>
                    <SubMenus />
                    <IconLeafMenus isActive={props.isActive} leafItems={leafItems} maxItems={props.maxItems} />
                </>
            }
        </>
    );
}


export const IconMenuItem2 = (props: IIconMenuProps & IIconSubMenu) => {

    const [isActive, setIsActive] = useState(false);
    const [isHover, setIsHover] = useState(false);
    const [isFocus, setIsFocus] = useState(false);

    const toggleHover = () => { setIsHover(!isHover); };
    const toggleActive = () => {
        const newState = (!isActive);
        setIsActive(newState);
        if (props.selectFn && newState) props.selectFn();
    };
    const toggleFocus = () => { setIsFocus(!isFocus) };

    // If leaf items are passed in but they aren't visible then 
    var isVisible = true;
    var leafItems = [] as Array<ILeafItem>;
    if (props.leafItems) {
        leafItems = (props.leafItems).filter(x => x.parent === props.text);
        isVisible = leafItems.length > 0;
    }

    var style = { backgroundColor: SetAlphaColor(props.color, (isHover || isFocus || isActive) ? '0.25' : '0.1') };
    var menuBarStyle = { backgroundColor: SetAlphaColor(props.color, '0.5') };

    return (
        <>
            {
                isVisible &&
                <>
                    <div className="icon-menu-item-container2 user-select-none"
                        onMouseOver={toggleHover}
                        onMouseOut={toggleHover}
                        onClick={toggleActive}
                        onFocus={toggleFocus}
                        style={style}
                    >
                        <div className="status-frame2" style={menuBarStyle} />
                        <div className="pt-2" >
                            <div style={{ float: 'left', height: '1.5rem', maxWidth: '3.25rem', minWidth: '3.25rem' }}>{props.icon}</div>&nbsp;<span >{props.text}</span>
                        </div>
                    </div>
                    <IconLeafMenus isActive={isActive} leafItems={leafItems} maxItems={props.maxItems} />
                </>
            }</>
    );
}

/* Icon headings */

export const MyActionsH1 = () => (<IconHeading icon={<MyActionsIcon fontSize="large" />} headingText="My Actions" />);
export const HistoryH1 = () => (<IconHeading icon={<History fontSize="large" />} headingText="Document History" width="400px" />);
export const AppsH1 = () => (<IconHeading icon={<Apps fontSize="large" />} headingText="Apps" width="230px" altColor={true} />);
export const QuickLinksH1 = () => (<IconHeading icon={<QuickLinksIcon fill="white" />} headingText="Quick Links" width="300px" altColor={true} />);

export const RailRulebookH2 = () => (<IconHeading2 icon={<RbRulebookFilled fill="white" />} headingText="Rulebook" altColor={true} />);
export const RailDocumentsH2 = () => (<IconHeading2 icon={<RbRulebookFilled fill="white" />} headingText="Rail Documents" altColor={true} />);
export const AllDocumentsH2 = () => (<IconHeading2 icon={<CurrentDocuments fontSize="large" />} headingText="All Documents" altColor={true} />);
export const MyDocumentsH2 = () => (<IconHeading2 icon={<CurrentDocuments fontSize="large" />} headingText="My Documents" />);

export const AddDocumentH2 = () => (<IconHeading3 icon={<AdminAddNewDocumentIcon fill="white" className="label-icon-h2 mr-3 ml-3" />} headingText="Add a new document" altColor={true} />);
export const EditDocumentH2 = () => (<IconHeading3 icon={<EditIcon fill="white" fontSize="large" className="mr-3 ml-3" />} headingText="Edit a document" altColor={true} />);
export const RescindDocumentH2 = () => (<IconHeading3 icon={<AdminRescindIcon fill="white" fontSize="large" className="mr-3 ml-3" />} headingText="Rescind document" altColor={true} />);
export const RelatedDocumentsH2 = () => (<IconHeading3 icon={<AddRelatedDocumentsIcon fontSize="large" style={{ color: 'transparent' }} />} headingText="Related documents" altColor={true} />);

export const DocumentInfoH2 = () => (<IconHeading3 icon={<Info fill="white" fontSize="large" className="mr-3 ml-3" />} headingText="Document information" altColor={true} />);


/* Icons */

export const MarkChatRead = () => (<MarkChatReadIcon className="MuiSvgIcon-root MuiSvgIcon-fontSizeLarge" focusable="false" />);


/* Buttons */

type IButtonProps =
    {
        onClick: () => void
    }

export const ModalClose = (props: { onClick: () => void, dark?: boolean }) => {
    return (<div onClick={props.onClick} className={`${props.dark ? 'text' : 'alternate-text'} rail-button close-button float-right`}><CancelIcon fontSize="large" /></div>);
}

export const RelatedDocumentsAddButton = (props: IButtonProps) => {
    return (<div onClick={props.onClick} className="alternate-text rail-button close-button float-right"><AddRelatedDocumentsIcon fontSize="large" /></div>);
}

type ITooltipProps =
    {

        text: string | React.ReactNode;
    }

type ITooltipLabelProps = ITooltipProps & {
    label: string 
}

export const ToolTipButton = (props: ITooltipProps) => (<div className="rail-tooltip ml-1" ><ToolTipIcon /><span className="tooltiptext">{props.text}</span></div>);
export const ToolTipLabel = (props: ITooltipLabelProps) => (<div style={{ display: "inline-block", whiteSpace: "nowrap" }}><Label  >{`${props.label}`} <ToolTipButton text={props.text} /></Label></div>);
export const ToolTipQuestionButton = (props: ITooltipProps) => (<div className="rail-tooltip ml-1" ><ToolTipQuestionIcon /><span className="tooltiptext">{props.text}</span></div>);
export const ValidationError = () => (<div className="rail-validation-error ml-1" ><ValidationIcon /></div>);

export type AllDocMenu =
    | "Current"
    | "Expired"
    | "Rescinded"
    | "Deleted"
    | "ALL";

// All Docs menu
export const AllDocumentsMenu = (props: { onMenuChanged?: (x: AllDocMenu) => void }) => {

    const [activeMenu, setActiveMenu] = useState(-1);
    const toggleActive = (menuIndex: number) => {
        setActiveMenu(menuIndex === activeMenu ? 0 : menuIndex);
    }

    const filter = (x: AllDocMenu) => {
        if (props.onMenuChanged) props.onMenuChanged(x)
    }

    const toggleActiveFilter = (x: AllDocMenu, menuIndex: number) => {
        const newMenu = menuIndex === activeMenu ? -1 : menuIndex;
        setActiveMenu(newMenu);
        filter(newMenu !== -1 ? x : "ALL");
    }

    const clr = colorCssMapping["nav-menu-all-documents-bg"];

    return (
        <React.Fragment>
            <div>
                <IconMenuItem1 icon={<Folder fontSize="large" />} text="Current" color={clr} isActive={activeMenu === 1} toggleActive={() => toggleActiveFilter("Current", 1)} />
            </div>
            <div>
                <IconMenuItem1 icon={<AdminExpiredDocumentsIcon className="label-icon-menu" />} text="Expired" color={clr} isActive={activeMenu === 2} toggleActive={() => toggleActive(2)} subMenus={[
                    { text: "Rescinded documents", selectFn: () => filter("Rescinded") },
                    { text: "Expired documents", selectFn: () => filter("Expired") }
                ]} />
            </div>
            <div>
                <IconMenuItem1 icon={<Delete className="label-icon-menu" />} text="Deleted" color={clr} isActive={activeMenu === 3} toggleActive={() => toggleActiveFilter("Deleted", 3)} />
            </div>
        </React.Fragment>
    );
}

export type MyDocMenu =
    | "AwaitingAction"
    | "RecentlyActioned"
    | "Favorites";

interface IFilterProps {
    filter: IDocumentFilter,
    isActive: boolean,
    activate: () => void
}

export const Filter = (props: IFilterProps) => {
    return (
        <div className={props.filter.className}>
            <IconMenuItem1 icon={props.filter.icon} text={props.filter.name}
                isActive={props.isActive} toggleActive={props.activate} color={colorCssMapping["status-requires-action-color"]} />
        </div>
    )
}

interface IModuleFilterListProps {
    title: string,
    selectedModule: IDocumentModule | null,
    setSelectedModule: (module: IDocumentModule | null) => void,
    modules?: IDocumentModule[],
    canSelectAll?: React.ReactNode
}

export const DocumentModuleFilterList = (props: IModuleFilterListProps) => {
    const updatedRulebookMode = getUserExistingRulebookMode();

    const rulebookModeSetting = RulebookNameToEnum(updatedRulebookMode);
    var items = props.modules ??
                (rulebookModeSetting === RulebookModeEnum.CBTC
                ? DocumentModules // For CBTC mode, use all defined modules
                : DocumentModules.filter(m => m.mode === rulebookModeSetting));

    const onChange = (event: any) => {
        let moduleId = parseInt(event.target.value);

        if (moduleId > -1) {
            props.setSelectedModule(items![moduleId]);
        }
        else {
            props.setSelectedModule(null);
        }
    }

    return (<div className="filter-by-module">
        <h4>
            Filter by module
        </h4>
        <FormGroup tag="fieldset" onChange={onChange}>
            {props.canSelectAll &&
                <FormGroup check>
                    <Label check>
                        <Input type="radio" name="module" value="-1" defaultChecked={true} />
                        All
                    </Label>
                </FormGroup>
            }

            {items.map((item, index) =>
                <FormGroup check key={index}>
                    <Label check> <Input type="radio" name="module" value={index} /> {item.name}</Label>
                </FormGroup>
            )}
        </FormGroup>
    </div>);
}

interface DocumentViewListProps {
    activeView: IDocumentView | null,
    setActiveView: (view: IDocumentView) => void
}

export const DocumentViewList = (props: DocumentViewListProps) => {
    const updatedRulebookMode = getUserExistingRulebookMode();
    return (
        <div className="document-view-list clickable">
            <Toggle label={props.activeView?.name} collapseOnChangeOf={props.activeView}>
                <div className="list-items">
                    {DocumentViews().filter(v => v.mode === RulebookNameToEnum(updatedRulebookMode)).map(view =>
                        <div key={view.name}
                            onClick={() => props.setActiveView(view)}
                            className={"item " + (view.name === props.activeView?.name ? "active" : "clickable")}>
                            {view.name}
                        </div>
                    )}
                </div>
            </Toggle>
        </div>
    );
};

interface IFilterSelector {
    activeFilter?: IDocumentFilter | null,
    setActiveFilter?: (filter: IDocumentFilter | null) => void
    activeSubFilter?: IDocumentFilter | null,
    setActiveSubFilter?: (filter: IDocumentFilter | null) => void
}

interface IDocumentFilterProps extends IFilterSelector {
    filter: IDocumentFilter,
    hideSubFilters?: boolean,
    documents?: RailDocument[] | null,
    selectedDocuments?: RailDocument[] | null,
    selectedDocumentId?: number,
    expanded: boolean,
    onDocumentClick?: (doc: RailDocument) => void
}

export const DocumentFilter = (props: IDocumentFilterProps) => {
    const Icon = props.filter.icon;
    const filterClassName = getClassName(props.filter);
    const isActive = props.activeFilter?.name === props.filter.name;

    const collapseSubFilter = () => {
        if (props.setActiveSubFilter) {
            props.setActiveSubFilter(null);
        }
    };

    const collapseThisFilter = () => {
        if (props.setActiveFilter) {
            props.setActiveFilter(null);
        }
    };

    const autoExpandFirstSubFilter = () => {
        if ((props.filter?.subFilters?.length ?? 0) > 0) {
            if (props.setActiveSubFilter && props.filter?.subFilters) {
                props.setActiveSubFilter(props.filter.subFilters[0]);
            }
        }
    };

    const thisIsTheCurrentFilter = () => (props.filter === props.activeFilter);
    const showingDocuments = () => (docs.length > 0);

    const setActiveFilter = (inFlightSubFilterChange: IDocumentFilter | null = null) => {
        if (thisIsTheCurrentFilter()) {
            // if we're showing documents, then allow it to collapse
            if (showingDocuments()) {
                collapseThisFilter();
            }
        } else {
            if (props.setActiveFilter) {
                // set this filter as the current filter
                props.setActiveFilter(props.filter);
            }

            if (!showingDocuments()) {
                // and thers no subfilter change in-flight (being called from setActiveSubFilter rather than directly)
                if (!inFlightSubFilterChange) {
                    autoExpandFirstSubFilter();
                }
            } else {
                collapseSubFilter();
            }
        }
    };

    const setActiveSubFilter = (subFilter: IDocumentFilter | null) => {
        if (props.setActiveSubFilter) {

            // if the user is click on the active sub filter, just remove it
            if (props.activeSubFilter === subFilter) {
                if (docs.length > 0) {
                    props.setActiveSubFilter(null);
                }
            }
            else {
                if (props.filter !== props.activeFilter) {
                    setActiveFilter(subFilter);
                }
                props.setActiveSubFilter(subFilter);
            }

        }
    };

    const sortDocs = (field: string, order: SortOrder, a: RailDocument, b: RailDocument) => {
        const aVal = evalPath(field, a);
        const bVal = evalPath(field, b);

        if (aVal === null && bVal === null) return 0;
        if (aVal === null) return (order === SortOrder.ASC ? -1 : 1);
        if (bVal === null) return (order === SortOrder.ASC ? 1 : -1);

        if (aVal < bVal) return (order === SortOrder.ASC ? -1 : 1);
        if (aVal > bVal) return (order === SortOrder.ASC ? 1 : -1);

        return 0;
    };

    const setDocs = () => {
        if (props.documents) {
            if (props.documents.length > 0) {
                var config = props.filter.rules?.gridConfig;

                if (config) {
                    const docs = props.documents.filter(doc => defaultDocumentFilter(doc, props.filter));

                    if (props.filter.defaultSortField) {
                        docs.sort((a, b) => sortDocs(props.filter.defaultSortField ?? "title", props.filter.defaultSortOrder ?? SortOrder.ASC, a, b));
                    }

                    return docs;
                }
            }

            return props.documents;
        }

        return [] as RailDocument[];
    };

    const docs = setDocs();
    const showSubFilters = ((props.filter.subFilters?.length ?? 0) > 0) && (!(props.hideSubFilters ?? false));
    const isParent = (docs.length > 0) || showSubFilters;

    const onClick = (doc: RailDocument) => {
        if (props.onDocumentClick) {
            props.onDocumentClick(doc);
        }
    };

    const isDocSelected = (id: number) => {
        if (props.selectedDocumentId) {
            return id === props.selectedDocumentId;
        }

        if (props.selectedDocuments) {
            return (props.selectedDocuments.findIndex(sd => sd.id === id) > -1);
        }

        return false;
    };

    const selectedCount = docs.filter(doc => (props.selectedDocuments?.some(sd => sd.id === doc.id))).length;

    const documentTypeAllowed = (filter: IDocumentFilter) => {
        if (filter.id === undefined) {
            return true;
        }

        let docTypes = useAllDocumentTypes();
        let childDocTypes = docTypes.flatMap(dt => dt.children);
        let isAllowed = docTypes.some(type => type.typeId === filter.id) || childDocTypes.some(type => type && type.typeId === filter.id);

        return isAllowed;
    }

    return (
        <>
            {documentTypeAllowed(props.filter) &&
                <div className={"filter-container" + (isParent ? ((isActive || props.expanded) ? " expanded" : " collapsed") : "") + (selectedCount === 0 ? " no-documents-selected" : "")}>
                    <div className={filterClassName + " clickable li-icon" + (isActive ? " active" : "")} onClick={() => setActiveFilter(null)}>
                        <div className="bullet" />
                        <div className="icon ccv"><Icon /></div>
                        <div className="label ccv"><span>{props.filter.name}</span></div>

                        {docs && props.selectedDocuments &&
                            <div className="selected-count">
                                <span className="count">{selectedCount}</span>
                                <span className="sep">/</span>
                                <span className="total">{docs.length}</span>
                            </div>

                        }
                        <div className="indicator ccv"><ArrowForwardIos /></div>
                    </div>

                    {showSubFilters &&
                        props.filter.subFilters?.map(sf =>
                            <div key={sf.name} className={filterClassName + " sub-filter"}>
                                <DocumentFilter
                                    documents={docs}
                                    expanded={false}
                                    selectedDocuments={props.selectedDocuments}
                                    onDocumentClick={props.onDocumentClick}
                                    selectedDocumentId={props.selectedDocumentId}
                                    filter={sf}
                                    activeFilter={props.activeSubFilter}
                                    setActiveFilter={setActiveSubFilter} />
                            </div>
                        )
                    }

                    {docs && (!showSubFilters || (props.filter?.subFilters?.length ?? 0) === 0) &&
                        <div className={"document-list-documents" + ((isActive || props.expanded) ? " expanded" : " collapsed")}>
                            <table>
                                <tbody>
                                    {docs.map(doc =>
                                        <tr key={doc.id}
                                            onClick={() => onClick(doc)}
                                            className={"document doc-" + doc.id + (isDocSelected(doc.id) ? " selected-document" : "")}>
                                            <td className="icon-col">
                                                <PdfIcon />
                                            </td>

                                            {props.selectedDocuments &&
                                                <td className="check-box-col">
                                                    {props.selectedDocuments && props.selectedDocuments.findIndex(sd => sd.id === doc.id) > -1
                                                        ? <CheckBoxOutlined />
                                                        : <CheckBoxOutlineBlankOutlined />
                                                    }
                                                </td>
                                            }
                                            <td className="title-col">{doc.title}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    }
                </div>
            }
        </>
    );
};

interface IDocumentFiltersProps extends IFilterSelector {
    view: IDocumentView | null,
    documentCount?: number,
    hideSubFilters?: boolean,
    selectedDocuments?: RailDocument[] | null,
    selectedDocumentId?: number,
    expandedFilters?: IDocumentFilter[],
    onDocumentClick?: (doc: RailDocument) => void
}

export const DocumentFilterList = (props: IDocumentFiltersProps) => {
    const [expanded, setExpanded] = useState(false);

    useEffect(() => {
        setExpanded(false);
    }, [props.activeFilter, props.activeSubFilter]);

    const allDocumentsHeading = "All documents" + (props.documentCount ? "(" + props.documentCount + ")" : "");

    const Icon = props.view?.icon || defaultDocumentIcon;

    const onClick = () => {
        if (props.setActiveFilter) {
            props.setActiveFilter(null);
        }
    };

    const viewNameFormat = (viewName: string | undefined) => {
        if (viewName === undefined) {
            return 'none';
        }
        return viewName.replaceAll(' ', '-');
    }

    return (
        <>
            <div className="document-filter-list-dropdown" onClick={() => setExpanded(!expanded)} >
                <div>{
                    props.activeSubFilter?.name
                    ?? props.activeFilter?.name
                    ?? allDocumentsHeading
                }</div>
            </div>

            <Floating
                className={`view-${viewNameFormat(props?.view?.name)} document-filter-list no-text-select ${(expanded ? "show" : "hide")}`}
                clickOutside={() => setExpanded(!expanded)}>
                {props.view?.filters?.map(filter =>
                    <DocumentFilter key={filter.name}
                        filter={filter}
                        expanded={props.expandedFilters?.includes(filter) ?? false}
                        activeFilter={props.activeFilter}
                        setActiveFilter={props.setActiveFilter}
                        activeSubFilter={props.activeSubFilter}
                        documents={props.view?.cache?.data}
                        selectedDocuments={props.selectedDocuments}
                        selectedDocumentId={props.selectedDocumentId}
                        onDocumentClick={props.onDocumentClick}
                        setActiveSubFilter={props.setActiveSubFilter}
                        hideSubFilters={props.hideSubFilters ?? false}
                    />
                )}
            </Floating>
        </>
    );
};

export const MyDocumentsMenu = (props: { onMenuChanged?: (x: MyDocMenu) => void }) => {
    const [activeMenu, setActiveMenu] = useState(1);

    const toggleActive = (menuIndex: number) => {
        setActiveMenu(menuIndex === activeMenu ? 0 : menuIndex);
    }

    const filter = (x: MyDocMenu) => { if (props.onMenuChanged) props.onMenuChanged(x) }

    const toggleActiveFilter = (x: MyDocMenu, menuIndex: number) => {
        toggleActive(menuIndex);
        filter(x);
    }

    return (
        <div>
            <div>
                <IconMenuItem1 icon={<AwaitingActionIcon fontSize="large" />} text="Awaiting action"
                    isActive={activeMenu === 1} toggleActive={() => toggleActiveFilter("AwaitingAction", 1)} color={colorCssMapping["status-requires-action-color"]} />
            </div>
            <div>
                <IconMenuItem1 icon={<RecentActionsIcon className="label-icon-menu" />} text="Recently actioned"
                    isActive={activeMenu === 2} toggleActive={() => toggleActiveFilter("RecentlyActioned", 2)} color={colorCssMapping["status-ok"]} />
            </div>
            <div>
                <IconMenuItem1 icon={<FavouriteIcon fontSize="large" />}
                    isActive={activeMenu === 3} toggleActive={() => toggleActiveFilter("Favorites", 3)} text="Favorites" color={colorCssMapping["favourites-color"]} />
            </div>
        </div>);
}

// Create the rail rulebook menu structure with optional leaf items (ie PDFs)
export const RailRulebookMenu = (props: {
    onMenuChanged?: (x: string, isSubMenu?: boolean) => void,
    leafItems?: ILeafItem[],
    activeMenuIndex?: number,
    maxItems?: number,
    includeRailDocs?: boolean,      // Include any menus that are not rulebook items
    exludeMenuKeys?: Array<string>  // Menu titles that you don't want displayed 
}) => {

    const exludeMenuKeys = props.exludeMenuKeys || [];
    // TODO more generic way of setting up menus
    const [activeMenu, setActiveMenu] = useState(-1);

    const filter = (x: string, isSubMenu?: boolean) => {
        if (props.onMenuChanged) {
            props.onMenuChanged(x, isSubMenu);
        }
    }

    const toggleActive = (menuIndex: number, x: string) => {
        const newMenu = menuIndex === activeMenu ? -1 : menuIndex;
        setActiveMenu(newMenu);
        filter(newMenu !== -1 ? x : "ALL");
    }

    useEffect(() => {
        if (props.activeMenuIndex !== undefined && props.activeMenuIndex > 0 && props.activeMenuIndex !== activeMenu) {
            setActiveMenu(props.activeMenuIndex);
        }
    });

    const NetworkRulesMenuButton =
        (p: { menuText: string }) => (<IconMenuItem1 icon={<RbNetworkRulesIcon className="label-icon-menu-rulebook" />} {...props} text={p.menuText} color={colorCssMapping["rb-network-rules-color"]} isActive={activeMenu === 1} toggleActive={() => toggleActive(1, p.menuText)} subMenus={[
            { icon: <RbNrGeneralRules className="label-icon-menu-rulebook" />, text: "General Rules", selectFn: () => filter("General Rules", true) },
            { icon: <RbNrRailTrafficOperations className="label-icon-menu-rulebook" />, text: "Rail Traffic Operations", selectFn: () => filter("Rail Traffic Operations", true) },
            { icon: <RbNrSignallingOperations className="label-icon-menu-rulebook" />, text: "Signalling Operations", selectFn: () => filter("Signalling Operations", true) },
            { icon: <RbNrWorkOnTrack className="label-icon-menu-rulebook" />, text: "Work on Track", selectFn: () => filter("Work on Track", true) },
            { icon: <RbNrGeneralRules className="label-icon-menu-rulebook" />, text: "Non MBS Territory", selectFn: () => filter("Non MBS Territory", true) }
        ]} />);

    const NetworkProceduresMenuButton =
        (p: { menuText: string }) => (<IconMenuItem1 icon={<RbNetworkProcsIcon className="label-icon-menu-rulebook" />} {...props} text={p.menuText} color={colorCssMapping["rb-network-procs-color"]} isActive={activeMenu === 2} toggleActive={() => toggleActive(2, p.menuText)} />);

    const NetworkRulesFormsMenuButton =
        (p: { menuText: string }) => (<IconMenuItem1 icon={<RbNetworkFormsIcon className="label-icon-menu-rulebook" />} {...props} text={p.menuText} color={colorCssMapping["rb-network-rules-forms-color"]} isActive={activeMenu === 4} toggleActive={() => toggleActive(4, p.menuText)} />);

    const RailTrafficOperationsManualMenuButton =
        (p: { menuText: string }) => (<IconMenuItem1 icon={<RbRailTrafficOperationsManualIcon />} {...props} text={p.menuText} color={colorCssMapping["rb-network-rail-traffic-operations-manual"]} isActive={activeMenu === 5} toggleActive={() => toggleActive(5, p.menuText)} />);

    const SignallingMenuButton =
        (p: { menuText: string }) => (<IconMenuItem1 icon={<RbSignallingIcon className="label-icon-menu-rulebook" />} {...props} text={p.menuText} color={colorCssMapping["rb-remote-control-signalling"]} isActive={activeMenu === 6} toggleActive={() => toggleActive(6, p.menuText)} />);

    const GlossaryMenuButton =
        (p: { menuText: string }) => (<IconMenuItem1 icon={<RbGlossary className="label-icon-menu-rulebook" />} {...props} text={p.menuText} color={colorCssMapping["rb-glossary"]} isActive={activeMenu === 7} toggleActive={() => toggleActive(7, p.menuText)} />);

    const OperatingNoticeButton =
        (p: { menuText: string }) => (<IconMenuItem1 icon={<OperatingInstructionsNoticesIcon className="label-icon-menu-rulebook" />} {...props} text={p.menuText} color={colorCssMapping["rail-docs-menu"]} isActive={activeMenu === 8} toggleActive={() => toggleActive(8, p.menuText)} />);

    const OperatingInstructionsButton =
        (p: { menuText: string }) => (<IconMenuItem1 icon={<OperatingInstructionsNoticesIcon className="label-icon-menu-rulebook" />} {...props} text={p.menuText} color={colorCssMapping["rail-docs-menu"]} isActive={activeMenu === 9} toggleActive={() => toggleActive(9, p.menuText)} />);


    return (
        <React.Fragment>
            {!exludeMenuKeys.includes("Network Rules") && <div><NetworkRulesMenuButton menuText="Network Rules" /></div>}
            {!exludeMenuKeys.includes("Network Procedures") && <div><NetworkProceduresMenuButton menuText="Network Procedures" /></div>}
            {!exludeMenuKeys.includes("Operating Notices and Instructions") && <div><OperatingNoticeButton menuText="Operating Notices and Instructions" /></div>}
            {!exludeMenuKeys.includes("Network Forms") && <div><NetworkRulesFormsMenuButton menuText="Network Forms" /></div>}
            {!exludeMenuKeys.includes("Rail Traffic Operations Manual") && <div><RailTrafficOperationsManualMenuButton menuText="Rail Traffic Operations Manual" /></div>}
            {!exludeMenuKeys.includes("Network Signals and Signs Manual") && <div><SignallingMenuButton menuText="Network Signals and Signs Manual" /></div>}
            {!exludeMenuKeys.includes("Glossary") && <div><GlossaryMenuButton menuText="Glossary" /></div>}
        </React.Fragment>
    )
};